import { analytics } from '@redislabsdev/cloud-ui-analytics';
import { useLayoutEffect } from 'react';
import { useTheme } from 'styled-components/macro';

export const ThemeChangeHandler = () => {
  const { mode } = useTheme() || {};

  useLayoutEffect(() => {
    if (mode) {
      document.body.classList.add('theme-transition');
      document.documentElement.setAttribute('theme', mode);
      window.sessionStorage.setItem('theme', mode);
      analytics.setGuidesAndSurveysTheme(mode === 'dark' ? 'darkMode' : 'lightMode');

      setTimeout(() => {
        document.body.classList.remove('theme-transition');
      }, 300);
    }
  }, [mode]);

  return null;
};
